import { render, staticRenderFns } from "./LayoutPublicFreelancer.vue?vue&type=template&id=4aa37199"
import script from "./LayoutPublicFreelancer.vue?vue&type=script&lang=js"
export * from "./LayoutPublicFreelancer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports